module.exports = __webpack_public_path__ + "static/media/IfYouCanDream.67f970ca.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Motivation/IfYouCanDream/IfYouCanDream.mp4
// module id = 379
// module chunks = 0